import React from 'react';

import { Form } from '@react/react-spectrum/Form';
import FieldLabel from '@react/react-spectrum/FieldLabel';
import Heading from '@react/react-spectrum/Heading';
import Textfield from '@react/react-spectrum/Textfield';

export default function DynamicsDetailsForm({ formData, setFormData }) {
  const handleChange = (fieldName) => (value) => {
    setFormData(fieldName, value);
  };

  return (
    <Form>
      <Heading size={3}>Dynamics 365 environment details</Heading>

      <FieldLabel label="Name">
        <Textfield
          placeholder="My Dynamics Instance"
          name="name"
          defaultValue={formData.name}
          onChange={handleChange('name')}
        />
      </FieldLabel>

      <FieldLabel label="Instance URL">
        <Textfield
          placeholder="https://XXXXX.crm.dynamics.com"
          name="instanceUrl"
          defaultValue={formData.details?.instanceUrl}
          onChange={handleChange('details.instanceUrl')}
        />
      </FieldLabel>

      <FieldLabel label="CRM Web API">
        <Textfield
          placeholder="https://XXXXX.api.crm.dynamics.com/api/data/v9.1"
          name="crmWebApi"
          defaultValue={formData.details?.crmWebApi}
          onChange={handleChange('details.crmWebApi')}
        />
      </FieldLabel>

      <FieldLabel label="Azure application object ID">
        <Textfield
          placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
          name="applicationObjectId"
          defaultValue={formData.details?.objectId}
          onChange={handleChange('details.objectId')}
        />
      </FieldLabel>

      <div className="username-password">
        <FieldLabel label="Client ID">
          <Textfield
            name="clientId"
            defaultValue={formData.credentials?.clientId}
            onChange={handleChange('credentials.clientId')}
          />
        </FieldLabel>
        <FieldLabel label="Client secret">
          <Textfield
            type="password"
            name="clientSecret"
            defaultValue={formData.credentials?.clientSecret}
            onChange={handleChange('credentials.clientSecret')}
          />
        </FieldLabel>
      </div>
    </Form>
  );
}
